import * as stylex from "@stylexjs/stylex";

export const styles = stylex.create({
  wideModal: {
    maxWidth: 640,
  },
  modalBody: {
    marginBottom: 16,
  },
  slugCell: {
    fontFamily: "monospace",
    fontSize: 13,
  },
  effectsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 12,
  },
  effectItem: {
    textAlign: "center",
    paddingBlock: 8,
    paddingInline: 12,
    borderRadius: 8,
    backgroundColor: "rgba(255,255,255,0.05)",
  },
  effectValue: {
    fontSize: 18,
    fontWeight: 600,
  },
  effectLabel: {
    fontSize: 11,
    marginTop: 2,
  },
  ruleCard: {
    paddingBlock: 12,
    paddingInline: 16,
    borderRadius: 8,
    backgroundColor: "rgba(255,255,255,0.03)",
    marginBottom: 8,
  },
  ruleHeader: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 8,
  },
  tagContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 4,
    alignItems: "center",
  },
  detailSection: {
    marginBottom: 16,
  },
  detailLabel: {
    fontSize: 12,
    marginBottom: 4,
  },
  flexWrap: {
    flexWrap: "wrap",
  },
  ruleNote: {
    marginTop: 8,
    fontStyle: "italic",
  },
});
